import { useNavigate, useSearchParams } from "react-router-dom";
import fetchData from "../../APIsControll/apiControll";
import { useAuth } from "../../components/context/Auth";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import styles from "./Invoice.module.css";
import { useEffect, useState } from "react";
import TextElement from "../../components/updatedComponents/FormComponents/TextElement";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
import { InfoRounded, NewEyeIcon } from "../../components/icons/Icon";
import Button from "../../components/updatedComponents/Dealers/Button";
import { Uploadinvoice } from "../../components/icons/Icon4";
import { ModalWrapper } from "../../exports";
import UploadInvoiceModal from "./UploadInvoiceModal";
import { getStatusColor } from "../../Utils/Utils";

const SaleInvoice = () => {
  const { mode, managerId } = useAuth();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const navigate = useNavigate();

  const [itemData, setitemData] = useState([]);
  const [receiptData, setReceiptData] = useState([]);
  const [shippingData, setShippingData] = useState({});
  const [orderData, setOrderData] = useState({});
  const [expandedReceiptId, setExpandedReceiptId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const getInvoiceData = async () => {
      const apiData = { managerId: managerId, orderId: orderId };
      try {
        const res = await fetchData("invoice/getInvoice", apiData);
        if (res.status === "success") {
          const { items, shippingInfo, ...restOrder } = res.data.order;
          setOrderData(restOrder);
          setShippingData(shippingInfo);
          setitemData(items);
          setReceiptData(res.data.receipt);
        }
      } catch (error) {
        console.error("Failed to fetch invoice data:", error);
      }
    };

    if (managerId) {
      getInvoiceData();
    }
  }, [managerId, orderId]);

  const toggleReceipt = (receiptId) => {
    setExpandedReceiptId(expandedReceiptId === receiptId ? null : receiptId);
  };

  const headerData = [
    "S. No.",
    "Item Number",
    "Product",
    "Quantity",
    "Unit",
    "Rate",
    "Amount",
  ];

  return (
    <>
      <ModalWrapper
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        noBtn
      >
        <UploadInvoiceModal
          mode={mode}
          close={() => setIsModalOpen(false)}
          managerId={managerId}
          orderId={orderId}
          totalAmount={orderData.totalAmount}
          invoiceStatus={orderData.invoiceStatus}
          orderStatus={orderData.status}
        />
      </ModalWrapper>
      <div
        className={styles.inv}
        style={{
          backgroundColor: mode && "#2C2E33",
          borderColor: mode && "#2C2E33",
        }}
      >
        <div className={styles.inv_scroll_wrapper}>
          <div className={styles.inv_top}>
            <div className={styles.inv_top_left}>
              <TopTabBar truncate={false} text={`Sale Invoice / ${orderId}`} />
            </div>
            <div className={styles.inv_top_right}>
              <TextElement
                label={"Voucher No. & Date:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={orderData.orderId + " / " + orderData.orderDate}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"12px"}
                type={"order"}
              />
              <TextElement
                label={"Order Status:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={orderData?.status}
                valueColor={getStatusColor(orderData?.status)}
                fontSize={"12px"}
                type={"order"}
              />
              <TextElement
                label={"Invoice Status:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={orderData?.invoiceStatus}
                valueColor={getStatusColor(orderData?.invoiceStatus)}
                fontSize={"12px"}
                type={"order"}
              />
            </div>
          </div>

          <div className={styles.inv_form}>
            <div className={styles.inv_form_1}>
              <div>
                <InputTag
                  labelText={"Dealer / Dealer ID"}
                  padding={"8px"}
                  fontSize={"12px"}
                  maxLength={1000}
                  readOnly={true}
                  value={`${orderData.name} / ${orderData.dealerId}`}
                />
              </div>
              <div>
                <InputTag
                  labelText={"Warehouse"}
                  padding={"8px"}
                  fontSize={"12px"}
                  maxLength={1000}
                  readOnly={true}
                  value={orderData.warehousename}
                />
              </div>
              <div>
                <InputTag
                  labelText={"Order Manager"}
                  padding={"8px"}
                  fontSize={"12px"}
                  maxLength={1000}
                  readOnly={true}
                  value={orderData.ordermanager}
                />
              </div>
              <div className={styles.courier_name}>
                <p style={{ color: mode && "#FFFFFF" }}>
                  {shippingData.courierName}
                </p>
                <InputTag
                  labelText={"Delivery Method"}
                  padding={"8px"}
                  fontSize={"12px"}
                  maxLength={1000}
                  readOnly={true}
                  value={shippingData.methodName}
                />
              </div>
            </div>
            <div className={styles.inv_form_2}>
              <InputTag
                labelText={"Billing Address"}
                padding={"8px"}
                fontSize={"12px"}
                maxLength={1000}
                readOnly={true}
                value={orderData.billingAddress}
              />
              <InputTag
                labelText={"Shipping Address"}
                padding={"8px"}
                fontSize={"12px"}
                maxLength={1000}
                readOnly={true}
                value={`${shippingData.street} ${shippingData.city} ${shippingData.district} ${shippingData.state} ${shippingData.pincode}`}
              />
            </div>
          </div>

          <ul className={styles.table}>
            <li
              className={`${styles.header} ${mode ? styles.header_dark : ""}`}
            >
              {headerData?.map((h, index) => (
                <div className={styles.entry_2} key={`${h}-${index}`}>
                  {h}
                </div>
              ))}
            </li>

            <div className={styles.table_list}>
              {itemData.map((item, index) => (
                <li
                  className={`${styles.row}  ${mode ? styles.row_dark : ""}`}
                  key={index}
                >
                  <div className={styles.entry_2}> {index + 1} </div>
                  <div className={styles.entry_2}>{item.itemNo}</div>
                  <div className={styles.entry_2}> {item.product_name} </div>
                  <div className={styles.entry_2}>{item.qty}</div>
                  <div className={styles.entry_2}> {item.unit}</div>
                  <div className={styles.entry_2}> {item.price}</div>
                  <div className={styles.entry_2}> {item.price * item.qty}</div>
                </li>
              ))}
            </div>
          </ul>

          <div className={`${styles.footer} ${mode ? styles.footer_dark : ""}`}>
            <div
              className={`${styles.receipt_data} ${
                mode ? styles.receipt_data_dark : ""
              }`}
            >
              <div
                className={`${styles.receipt_data_header} ${
                  mode ? styles.receipt_data_header_dark : ""
                }`}
              >
                <div className={styles.receipt_entry}>Receipt ID</div>
                <div className={styles.receipt_entry}>Method</div>
                <div className={styles.receipt_entry}>Amount</div>
                <div className={styles.receipt_entry}>Status</div>
                <div
                  className={styles.receipt_entry}
                  style={{ visibility: "hidden" }}
                >
                  sasa
                </div>
              </div>
              <div
                className={styles.scroll_con}
                style={{ display: receiptData?.length === 0 && "none" }}
              >
                {receiptData?.length !== 0 &&
                  receiptData?.map((r, index) => (
                    <div
                      className={`${styles.receipt_data_entry} ${
                        mode ? styles.receipt_data_entry_dark : ""
                      }`}
                      key={r.receiptId}
                    >
                      <div
                        className={styles.receipt_entry}
                        key={index + r.receiptId}
                      >
                        {r.receiptId}
                      </div>
                      <div
                        className={styles.receipt_entry}
                        key={index + r.paymentMethod}
                      >
                        {r.paymentMethod}
                      </div>
                      <div
                        className={styles.receipt_entry}
                        key={index + r.paymentAmount}
                      >
                        {r.paymentAmount}
                      </div>
                      <div
                        className={styles.receipt_entry}
                        key={index + r.status}
                        style={{ color: getStatusColor(r.status) }}
                      >
                        {r.status}
                      </div>
                      <div
                        className={`${styles.receipt_entry} ${styles.info_btn_con}`}
                      >
                        <span
                          className={styles.info_btn}
                          onClick={() => toggleReceipt(r.receiptId)}
                        >
                          <InfoRounded />
                        </span>
                      </div>
                      <div
                        className={`${styles.acc_info} ${
                          expandedReceiptId === r.receiptId
                            ? styles.visible
                            : styles.hidden
                        }`}
                        style={{ backgroundColor: mode && "#1B1D21" }}
                        key={`Accounts${r.receiptId}`}
                      >
                        <TextElement
                          label={"Account Number:"}
                          labelColor={mode ? "#fff" : "#646B88"}
                          value={r.accountNumber}
                          valueColor={mode ? "#fff" : "#646B88"}
                        />
                        <div style={{ height: "10px" }} />
                        <TextElement
                          label={"IFSC Code:"}
                          labelColor={mode ? "#fff" : "#646B88"}
                          value={r.ifscCode}
                          valueColor={mode ? "#fff" : "#646B88"}
                        />
                      </div>
                    </div>
                  ))}
              </div>
            </div>

            <div className={styles.footer_right}>
              <div className={styles.right_btns}>
                <Button
                  buttonIcon={<Uploadinvoice />}
                  buttonText={"Upload"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  buttonClick={() => setIsModalOpen(true)}
                />
                <Button
                  buttonIcon={<NewEyeIcon />}
                  buttonText={"Order"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  buttonClick={() =>
                    navigate("/orders/order/saleorder?orderId=" + orderId)
                  }
                />
                <Button
                  buttonIcon={<NewEyeIcon />}
                  buttonText={"Invoice"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  buttonClick={() =>
                    navigate("/invoices/uploadedinvoice?orderId=" + orderId)
                  }
                />
              </div>

              <div
                className={`${styles.amount_info} ${
                  mode ? styles.amount_info_dark : ""
                }`}
              >
                <div>
                  <p>Sub Total:</p>
                  <p>₹ {orderData.subtotal}</p>
                </div>

                <div className={styles.shipping}>
                  <p>Shipping Charges:</p>

                  <div className={styles.check}>
                    <p>To Pay</p>
                    <input
                      type="checkbox"
                      value={orderData.toPay}
                      checked={orderData.toPay}
                    />
                  </div>

                  <p>₹ {shippingData.shippingCharge}</p>
                </div>

                <div>
                  <p>Total Amount(INR):</p>
                  <p>
                    <>₹ {orderData.totalAmount}</>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SaleInvoice;
